import styled from "styled-components";
import { Form } from "react-bootstrap";

export const StyledWrapper = styled(Form.Label)`
  .hidden-radio {
    visibility: hidden;
    display: none;
  }
  .selected-company {
    border: 1.5px solid var(--tertiary-color);
  }
`;

export const StyledSelectCompany = styled.div`
  cursor: pointer;
  position: relative;
  height: 140px;
  background: #e7f0fa;
  border-radius: 8px;
  font-size: var(--font-size-sm);
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--tertiary-color);
  @media screen and (max-width: 576px) {
    height: 100px;
    font-size: var(--font-size-xs);
  }
  &:hover {
    border: 1.5px solid var(--tertiary-color);
  }
  .dropdown-toggle:focus {
    box-shadow: none !important;
  }
  img {
    @media screen and (max-width: 576px) {
      width: 65px;
    }
  }
  .drop-down {
    position: absolute;
    top: -10px;
    left: 10px;
    i {
      font-size: var(--font-size-xxl);
      font-style: normal;
      color: #1c3542;
      @media screen and (max-width: 576px) {
        font-size: var(--font-size-md);
      }
    }
  }
  .dropdown-menu {
    min-width: 70px;
    height: 70px;
    background: var(--white-color);
    box-shadow: var(--box-shadow1);
    border-radius: 6px;
    font-size: var(--font-size-xs);
    color: var(--field-color);
  }
`;
